/**
 * 共享 Fetcher 实例
 *
 * 避免在各 API 文件中重复配置
 */

import { createFetch } from './createFetch';
import { getDomain } from './domain';

/** 内容 Fetcher - 请求静态 JSON 资源 (同域) */
export const contentFetcher = createFetch({
    baseUrl: window.location.origin,
});

/** API Fetcher - 请求后端接口 (跨域) */
export const apiFetcher = createFetch({
    baseUrl: getDomain(),
    headers: { Accept: 'application/json' },
});
